import AppSocials from './AppSocials';

export default AppSocials;
